// extracted by mini-css-extract-plugin
export default {"time_recorded_gridheight":"time_time_recorded_gridheight__UaTU4","form":"time_form__6krfM","popup-content":"time_popup-content__v0hNa","action_btn":"time_action_btn__8jYXv"};